/**
 * 取引先追加モーダル
 */

import { useState } from "react";
import { Modal, Stack, TextInput, Group, Button } from "@mantine/core";

interface PartnerAddModalProps {
  opened: boolean;
  onClose: () => void;
  onAdd: (officialName: string) => Promise<void>;
}

/**
 * 取引先追加モーダル
 */
export function PartnerAddModal({ opened, onClose, onAdd }: PartnerAddModalProps) {
  const [newOfficialName, setNewOfficialName] = useState("");

  const handleAdd = async () => {
    if (!newOfficialName.trim()) return;
    await onAdd(newOfficialName.trim());
    setNewOfficialName("");
    onClose();
  };

  const handleClose = () => {
    setNewOfficialName("");
    onClose();
  };

  return (
    <Modal opened={opened} onClose={handleClose} title="取引先を新規登録">
      <Stack>
        <TextInput
          label="正式名称"
          placeholder="例: ヤマエ久野株式会社"
          value={newOfficialName}
          onChange={(e) => setNewOfficialName(e.target.value)}
        />
        <Group justify="flex-end">
          <Button variant="default" onClick={handleClose}>
            キャンセル
          </Button>
          <Button onClick={handleAdd} disabled={!newOfficialName.trim()}>
            登録
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
